import React from 'react';
import Proptypes from 'prop-types';
import 'Components/Utility/Alert.scss';

export default function Alert({ status, children, border }) {
  return (
    <div className={`d-flex align-items-center p-2 mb-2 alert-status ${border ? 'border' : ''} status-${status}${border ? '-border' : ''}`}>
      {children}
    </div>
  );
}

Alert.propTypes = {
  status: Proptypes.string,
  border: Proptypes.bool,
  children: Proptypes.element,
};

Alert.defaultProps = {
  status: 'warning',
  border: false,
  children: <React.Fragment />,
};
